import * as React from "react";
import { Label } from "components/bootstrap";
export const STATUS_LABEL = {
  "all good": "All good",
  "heads up": "Heads up"
};
const STATUS_STYLE = {
  "all good": "success",
  "heads up": "warning"
};
const StatusBadge = ({ status }) => /* @__PURE__ */ React.createElement(Label, { bsStyle: STATUS_STYLE[status], uppercase: true }, STATUS_LABEL[status]);
export default StatusBadge;
